import SPACES from '@web-ui-kit/spaces'
import { styled, css } from 'styled-components'
import { DEVICE_SIZE } from 'utils/constants'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: ${SPACES['3XL']} 0;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    padding: ${SPACES['5XL']} 0;
  }
`
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACES.L};
  text-align: center;
  & > h3 {
    margin: 0;
  }
`
export const Content = styled.div`
  ${({ $isText }) =>
    $isText
      ? css`
          margin-top: ${SPACES.XL};
          margin-bottom: ${SPACES['2XL']};
          @media (min-width: ${DEVICE_SIZE.TABLET}) {
            margin-bottom: ${SPACES['4XL']};
          }
        `
      : css`
          margin-top: ${SPACES['2XL']};
          margin-bottom: ${SPACES.XL};
          @media (min-width: ${DEVICE_SIZE.TABLET}) {
            margin-top: ${SPACES['4XL']};
          }
        `}
`

export const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${SPACES.M};
  width: 100%;
  & > button:first-child {
    max-width: 29.0625rem;
    width: 100%;
  }
`
